import { Dispatch, SetStateAction } from "react";
import { CostCenterData } from "~/application/types/entities/CustomerBI.type";
import { Box } from "~/components/Box";
import { Card } from "~/components/Card";
import { Flex } from "~/components/Flex";
import { Text } from "~/components/Text";
import { H4 } from "~/components/Typography";
import { asCurrency } from "~/utils/mask.utils";

type CostCenterResumeProps = {
  costCenterSummary?: CostCenterData[];
  selectedCostCenters?: string[];
  onSelectMultiValues: ({ value, field }: { value: string; field: "costCenter" }) => void;
  selectedMultiValues: {
    costCenter: string[];
  };
};

export function CostCenterResume({
  costCenterSummary,
  onSelectMultiValues,
  selectedCostCenters,
  selectedMultiValues,
}: CostCenterResumeProps) {
  return (
    <Card css={{ overflow: "hidden", height: "600px" }}>
      <Box css={{ p: "$5" }}>
        <H4>Valor por centro de custo</H4>
      </Box>
      <Box css={{ maxHeight: "fit-content", overflow: "auto" }}>
        {costCenterSummary?.map((costCenter) => (
          <Flex
            key={costCenter.name}
            onClick={() => onSelectMultiValues({ value: costCenter.uuid, field: "costCenter" })}
            justify="between"
            css={{
              p: "$4",
              borderRadius: "$2",
              alignItems: "center",
              cursor: "pointer",
              backgroundColor: selectedMultiValues.costCenter?.includes(costCenter.uuid)
                ? "$primary-light"
                : "transparent",
              borderBottom: "1px solid $neutrals-lightest",
              "&:hover": {
                backgroundColor: "$neutrals-lightest",
              },
            }}
          >
            <Flex align="center" gap="4">
              <Flex gap="1" direction="column" justify="center">
                <Text fw="600">{costCenter.name}</Text>
                <Text css={{ fontSize: "$sm", color: "$neutrals-darkest" }}>
                  Último pedido: {costCenter.lastOrderDate}
                </Text>
              </Flex>
            </Flex>
            <Text fw="700" css={{ color: "$success-base" }}>
              {asCurrency(costCenter.value)}
            </Text>
          </Flex>
        ))}
      </Box>
    </Card>
  );
}